<template>
	<div> 
		<b-modal ref="image-preview" id="image-preview">
			<img
				:src="downloadFileUrl(filePreview) || '#'"
				class="w-full"
				v-if="filePreview"
			/>
			<div slot="modal-footer">
				<a
					class="btn btn-primary"
					v-if="filePreview"
					:href="
						filePreview ? downloadFileUrl(filePreview) : '#'
					"
				>
					{{ $t("download") }}
				</a>
			</div>
		</b-modal>
		<div class="form-group">
			<label v-if="field.question">
				{{ field.question }}
				<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
			</label>
            <small 
                v-if="requiredIncomplete"
                class="ml-1" style="color:#FF0000"    
            >
                {{  $t('required')}}
            </small>
			<div v-if="field.description" v-html="field.description"></div>
			<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
			<b-form-file
				multiple
				v-model="newFiles"
				:placeholder="$t('choose-file-or-drop-here-ellipses')"
				:drop-placeholder="$t('drop-file-here-ellipses')"
				accept=".doc, .docx, .pdf, .xls, .xlsx, .csv, .jpg, .jpeg, .gif, .png"
				class="mb-4"
				:disabled="readonly"
				:browse-text="$t('browse')"
				@input="uploadFiles"
				:state="Boolean(newFiles)"

			></b-form-file>
		</div>

		<div class="mb-3" v-if="newFiles && newFiles.length">
			{{ $t("files-uploading-colon") }}
			<div v-for="(newFile, fileIndex) in newFiles" v-bind:key="fileIndex">
				{{ $t("selected-file-colon") }} {{ newFile.name }}
			</div>
		</div>

		<div class="alert alert-danger" v-if="uploadError">
			{{ uploadError }}
		</div>

		<div
			v-if="field.value && Array.isArray(field.value) && field.value.length"
			class="list-group mb-3"
		>
			{{ $t("attachments-colon") }}
			<div
				class="inline list-group-item mt-2"
				v-for="file in field.value"
				v-bind:key="file.value"
			>
				<template v-if="!isBrokenAsset(file)">
					<a
						href="#"
						class="image-preview mr-2"
						v-if="getFileIcon(file) === 'file-earmark-image'"
						@click="previewFile(file)"
					>
						<div class="image-preview-overlay">
							<b-icon icon="eye-fill"></b-icon>
						</div>
						<img
							:src="downloadFileUrl(file)"
							alt="#"
						/>
					</a>
					<a
						:href="downloadFileUrl(file)"
						target="_blank"
						class="btn btn-link"
					>
						<b-icon :icon="getFileIcon(file)"></b-icon>
						{{ $t("download-filename", { filename: file.name }) }}
					</a>
				</template>
				<template v-else>
					<b-icon :icon="getFileIcon(file)"></b-icon>
					{{ file.name  }}					
				</template>
				<button
					class="btn float-right mt-2"
					@click="deleteFile(file)"
				>
					<b-icon icon="trash"></b-icon>
				</button>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	props: ['field', 'readonly','viewAs'],
	data() {
		return {
			newFiles: [],
			//DetailedFiles: [],			
			uploadError: null,
			filePreview: null,
			brokenAssetIds: [],
			viewinfo: false
		};
	},	
	mounted() {
		if(!Array.isArray(this.field.value)) {
			this.field.value = [];
		}
	},
	methods: {
		isBrokenAsset(file) {
			return this.brokenAssetIds.includes(file.value);
		},
		imageError(file) {
			this.brokenAssetIds.push(file.value);
		},
		getFileIcon(file) {
			const map = {
				doc: "file-earmark-text",
				docx: "file-earmark-text",
				pdf: "file-earmark-text",
				xls: "file-earmark-spreadsheet",
				xlsx: "file-earmark-spreadsheet",
				csv: "file-earmark-spreadsheet",
				jpg: "file-earmark-image",
				jpeg: "file-earmark-image",
				gif: "file-earmark-image",
				png: "file-earmark-image"
			};
			return map[file.ext.toLowerCase()] !== undefined
				? map[file.ext.toLowerCase()]
				: "file-earmark";
		},
		previewFile(file) {
			this.filePreview = file;
			this.$refs["image-preview"].show();			
		},
		downloadFileUrl(file) {

			return (
				`${this.$settings.APIBaseURL}/forms/downloadfile` +
				"?" +
				"username=" +
				this.$UserSession.getValue.call(this, "username") +
				"&authToken=" +
				this.$UserSession.getValue.call(this, "authToken") +
				"&formresponse_id=" +
				this.$route.params.formresponseid +
				"&asset_id=" +
				file.value
			);
		},

		deleteFile(file) {
			// todo: create /forms/deleteupload controller and call that here
			let self = this;
			this.field.value.forEach(function(item, fileIndex) {
				if (item.value == file.value) {
					self.field.value.splice(fileIndex, 1);
				}
			});			
		},
		uploadFiles: function() {
			if (this.newFiles && this.newFiles.length) {
				this.uploadError = null;

				if (this.$route.params.formresponseid) {
					let self = this;

					let data = new FormData();
					data.append("username", this.$UserSession.getValue.call(this, "username"));
					data.append("authToken", this.$UserSession.getValue.call(this, "authToken"));

					this.newFiles.forEach(function(item, index) {
						data.append("files[" + index + "]", item);
					});

					data.append('formresponse_id', this.$route.params.formresponseid);

					fetch(`${this.$settings.APIBaseURL}/forms/uploadfile`, {
						method: "post",
						body: data
					})
						.then(result => {
							this.$log.info.call(this, result);
							if (result.status === 200) {
								result.json().then(json => {
									this.$log.info.call(this, JSON.stringify(json));
									if (json.status === "SUCCESS") {
										self.$log.info.call(this, "File uploaded");

										json.result.forEach(function(item/*, index*/) {
											self.field.value.push({
												name: item.asset_title,
												ext: item.asset_extension,
												value: item.asset_id
											});
										});
									} else {
										this.$log.error.call(this, "Could not upload file(s)");
										this.uploadError = this.$t("could-not-upload-files");
									}
								});
							} else {
								this.$log.error.call(this, "Could not upload file(s)");
								this.uploadError = this.$t("could-not-upload-files");
							}
							this.newFiles = [];
						})
						.catch(error => {
							this.$log.error.call(this, error);
							this.newFiles = [];
							this.uploadError = this.$t("could-not-upload-files");
						});
				} else {
					this.uploadError = 'No form response ID';
				}
			}
		},	
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        }
	},
    computed: {
        requiredIncomplete() {
          return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
          && this.field.required && this.field.value.length == 0;
        },
        hasInfo() {
        	if(this.field.info){
        		return true;
        	}
        	return false;
        }
    }
};
</script>
